import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router'
import createHistory from 'history/createBrowserHistory'
import initGa from './services/googleAnalytics'

import App from './App'
import routes from './constants/routes'

// Global Styles
import './styles'

const history = createHistory()

initGa(history)

export const WrappedApp = (
  <Router history={history}>
    <App routes={routes} />
  </Router>
)

export const init = el => {
  if (el) {
    ReactDOM.render(WrappedApp, el)
  }
}

init(document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js